// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"50":"5f2cc6ed1f744b9d","2177":"8e961cff4d8f2858"}[chunkId] + ".js";
};